import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-card-message',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './card-message.component.html',
    styleUrl: './card-message.component.scss'
})
export class CardMessageComponent {
    @Input()
    textOnly = false;

    @Input()
    back = false;

    @Input()
    compact = false;

    @Input()
    muted = false;
}
